import userModule from "../assets/images/userModule.svg";
import complaintModule from "../assets/images/complaintModule.svg";
import siteModule from "../assets/images/siteModule.svg";
import factoryModule from "../assets/images/factoryModule.svg";
import cylinderModule from "../assets/images/cylinderModule.svg";
import expenseModule from "../assets/images/expenseModule.svg";

export const moduleList = [
  {
    moduleTitle: "user",
    moduleIcon: userModule,
    route: "/user/all",
    permission: "view_user",
  },
  {
    moduleTitle: "expense",
    moduleIcon: expenseModule,
    route: "/expense/all",
  },
  {
    moduleTitle: "complaint",
    moduleIcon: complaintModule,
    route: "/complaint/all",
    permission: "view_complaint",
  },
  {
    moduleTitle: "site manager",
    moduleIcon: siteModule,
    route: "/site/all",
    permission: "view_site",
  },
  {
    moduleTitle: "cylinder tracking",
    moduleIcon: cylinderModule,
    route: "/sites/cylinders",
    permission: "view_cylinder",
  },
  {
    moduleTitle: "factory",
    moduleIcon: factoryModule,
    route: "/factory/add-job-card",
    permission: "checkpoint_access",
  },
];
